import { bicyclePedestrianAddComponent } from './bicycle-pedestrian-add.component';

export const bicyclePedestrianAdd = angular
	.module('components.transportationAlternative.bicyclePedestrian.bicyclePedestrianAdd', [])
	.component('bicyclePedestrianAdd', bicyclePedestrianAddComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/bicycle-pedestrian/bicycle-pedestrian-add/bicycle-pedestrian-add.module.js